// extracted by mini-css-extract-plugin
module.exports = {"listIcon":"_2y_1zA0j7s3uymWpTGboXF","logo":"_3qi1pl70AkdLdNWlPZBDgI"};